/**
 * Role menu / route access — mirrors existing Sidebar rules.
 * Authorized roles keep the same pages; unauthorized URL access is blocked.
 */

export const getMenuItemsForUser = (user) => {
  switch (user?.role) {
    case 3:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrievanceList", label: "Grievances", icon: "bi-people-fill" },
        ...(user.UNIT_CENTRE_ID === "1"
          ? [
              { to: "/GrantList", label: "Grants", icon: "bi-building-fill" },
              {
                to: "/AresaUserList",
                label: "Users",
                icon: "bi-person-circle",
              },
              { to: "/IdCardList", label: "IDCard", icon: "bi-person-vcard" },
            ]
          : []),
        { to: "/CenterList", label: "Aresa Centers", icon: "bi-geo-alt" },
        { to: "/EventList", label: "Events", icon: "bi-calendar-check" },
        { to: "/PolicyList", label: "Policy", icon: "bi-file-earmark-text" },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    case 2:
      // ARESA Center
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrievanceList", label: "Grievances", icon: "bi-people-fill" },
        { to: "/GrantList", label: "Grants", icon: "bi-building-fill" },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    // DGAR DASHBOARD
    case 4:
    // Brig Pers
    case 6:
    // ADG DASHBOARD
    case 7:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrievanceList", label: "Grievances", icon: "bi-people-fill" },
        { to: "/GrantList", label: "Grants", icon: "bi-building-fill" },
        { to: "/IdCardList", label: "IDCard", icon: "bi-person-vcard" },
        { to: "/AresaUserList", label: "Users", icon: "bi-person-circle" },
        { to: "/CenterList", label: "Aresa Centers", icon: "bi-geo-alt" },
        { to: "/EventList", label: "Events", icon: "bi-calendar-check" },
        { to: "/PolicyList", label: "Policy", icon: "bi-file-earmark-text" },
        {
          to: "/EscalationMetrics",
          label: "Esclation Matrix",
          icon: "bi-graph-up-arrow",
        },
        {
          to: "/EscalatedGrievances",
          label: "Escalated Grievances",
          icon: "bi-arrow-up-circle-fill",
        },
        {
          to: "/EscalatedGrants",
          label: "Escalated Grants",
          icon: "bi-arrow-up-square-fill",
        },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    case 5:
    case 8:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrievanceList", label: "Grievances", icon: "bi-people-fill" },
        { to: "/GrantList", label: "Grants", icon: "bi-building-fill" },
        {
          to: "/EscalatedGrievances",
          label: "Escalated Grievances",
          icon: "bi-arrow-up-circle-fill",
        },
        {
          to: "/EscalatedGrants",
          label: "Escalated Grants",
          icon: "bi-arrow-up-square-fill",
        },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    case 9:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrievanceList", label: "Grievances", icon: "bi-people-fill" },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    case 10:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/GrantList", label: "Grants", icon: "bi-building-fill" },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    case 11:
      return [
        {
          to: "/Dashboard",
          label: "Dashboard",
          icon: "bi-speedometer2",
          exact: true,
        },
        { to: "/IdCardList", label: "IDCard", icon: "bi-person-vcard" },
        {
          to: "/ChangePassword",
          label: "ChangePassword",
          icon: "bi bi-shield-lock",
        },
      ];

    default:
      return [];
  }
};

/** Detail / nested routes inherit access from their parent list page. */
const ROUTE_ALIASES = {
  "/GrievanceDetails": "/GrievanceList",
  "/GrantDetails": "/GrantList",
  "/EscalatedGrievancesDetails": "/EscalatedGrievances",
  "/EscalatedGrantsDetails": "/EscalatedGrants",
  "/AresaUserDetails": "/AresaUserList",
  "/CenterDetails": "/CenterList",
  "/UpdateCenterList": "/CenterList",
  "/IdCardDetails": "/IdCardList",
};

export const canAccessRoute = (user, pathname) => {
  if (!user) return false;

  const path = pathname?.split("?")[0] || "";

  // Safe landing page for all authenticated users (avoids redirect loops)
  if (path === "/Dashboard") {
    return true;
  }

  // Registration was listed (commented) under roles 4/6/7 only
  if (path === "/Registration") {
    return [4, 6, 7].includes(user.role);
  }

  const requiredPath = ROUTE_ALIASES[path] || path;
  const menuItems = getMenuItemsForUser(user);
  return menuItems.some((item) => item.to === requiredPath);
};
